module.exports = __webpack_public_path__ + "static/media/pricing-icon_professional.5985beae.svg";